import { LineItem } from '~/commons/interfaces/models/checkout/cart/line-item/LineItem'

export function joinCartItemPayloadOptions(item: LineItem): string {
  return (
    (item.payload as any).options?.map((o: any) => o.option).join(', ') || ''
  )
}
